import { Auditable } from '@models/auditable';
import { ISODatetime } from '@models/date';
import { OrgRole } from '@models/orgRole';
import { ndefault } from '@models/util';
import z from 'zod';

export type AlertSettings = z.infer<typeof AlertSettings>;

export const AlertSettings = z.object({
  digest: z.boolean().nullish(),
  enabled: z.boolean().nullish(),
  schedules: ndefault(z.string().array(), []),
});

export const EmailVerificationToken = z.object({
  createdOn: ISODatetime,
  expiresOn: ISODatetime,
  value: z.string(),
  purpose: z.string(),
});

export type EmailCommunicationMethod = z.infer<typeof EmailCommunicationMethod>;

export const EmailCommunicationMethod = z.object({
  address: z.string(),
  alertSettings: AlertSettings.nullish(),
  confirmedOn: ISODatetime.nullish(),
  verificationTokens: EmailVerificationToken.array().nullish(),
});

export type SmsCommunucationMethod = z.infer<typeof SmsCommunicationMethod>;

export const SmsCommunicationMethod = z.object({
  number: z.string(),
  alertSettings: AlertSettings.nullish(),
});

export type User = z.infer<typeof User>;

export const User = Auditable.extend({
  id: z.string(),
  userName: ndefault(z.string(), ''),
  firstName: ndefault(z.string(), ''),
  lastName: ndefault(z.string(), ''),
  password: z.string().nullish(),
  orgRoles: ndefault(z.array(OrgRole), []),
  disabled: z.boolean().nullish(),
  lastLogin: ISODatetime.nullish(),
  timezone: z.string().nullish(),
  language: z.string().nullish(),
  email: EmailCommunicationMethod.nullish(),
  phone: SmsCommunicationMethod.nullish(),
});

export type PublicUserEmail = z.infer<typeof PublicUserEmail>;
export const PublicUserEmail = z.object({
  address: z.string(),
  isConfirmed: z.boolean(),
  verificationTokenExpiresOn: ISODatetime.nullish(),
});

export type PublicUser = z.infer<typeof PublicUser>;

export const PublicUser = z.object({
  v: z.number().nullish(),
  id: z.string(),
  userName: ndefault(z.string(), ''),
  firstName: ndefault(z.string(), ''),
  lastName: ndefault(z.string(), ''),
  orgRoles: ndefault(z.array(OrgRole), []),
  email: PublicUserEmail.nullish(),
});
